import { Pipe, PipeTransform } from '@angular/core';
import { IDropdownOption } from '@app/shared/common/dropdown/DropdownOption';
import { isNil } from 'lodash';

import { nullable } from '../common-types';

@Pipe({
    name: 'selectedAwareOptions',
    standalone: true,
})
export class SelectedAwareOptionsPipe implements PipeTransform {
    transform(selected: nullable<IDropdownOption>, options: IDropdownOption[]): IDropdownOption[] {
        const list = options ?? [];
        if (isNil(selected) || list.some((o) => o.key === selected.key)) {
            return list;
        }

        return [...list, selected];
    }
}
